// src/app/RequireAdminBusiness.tsx
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { fetchAdminMe } from "../auth/auth";

export default function RequireAdminBusiness({ children }: { children: React.ReactNode }) {
    const nav = useNavigate();
    const loc = useLocation();
    const { t } = useTranslation();

    const [checking, setChecking] = React.useState(true);

    React.useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                const me = await fetchAdminMe();
                const active = me?.active_business_id;

                if (!active) {
                    nav("/app/select-business", { replace: true, state: { from: loc.pathname } });
                    return;
                }
            } catch (e: any) {
                const msg = String(e?.message || "");
                if (msg === "UNAUTHORIZED") {
                    nav("/login", { replace: true });
                    return;
                }
                // Αν συμβεί άλλο error, για τώρα στείλ’ τον login (safe fallback)
                nav("/login", { replace: true });
                return;
            } finally {
                if (mounted) setChecking(false);
            }
        })();

        return () => {
            mounted = false;
        };
    }, [nav, loc.pathname]);

    if (checking) {
        return (
            <Box sx={{ py: 4 }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <CircularProgress size={18} />
                    <Typography color="text.secondary">{t("common.loading")}</Typography>
                </Stack>
            </Box>
        );
    }

    return <>{children}</>;
}
